import { Inject, Injectable, Injector } from '@angular/core';
import { ApiServiceBase } from './api-service-base';
import { API_BASE_URL } from './config.service';
import { AuthorizationDetail, ServiceLineGridDetail, ServiceLineGridPreview } from '@core/model';
import { catchError, Observable } from 'rxjs';
import { UrlConstants } from './url-constants';

@Injectable()
export class AuthorizationDecisionService extends ApiServiceBase {

  constructor(
      injector: Injector,
      @Inject(API_BASE_URL) private apiBaseUrl: string
    ) {
      super('AuthorizationDecisionService', injector);
    }

    FetchDuplicateServiceLine(tenantId: string,authorizationNumber: string, serviceLine: AuthorizationDetail): Observable<ServiceLineGridPreview> {
        const url = `${this.apiBaseUrl}${UrlConstants.FetchDuplicateServiceLine}/${tenantId}/${authorizationNumber}`;

        return this.httpUtility.post<ServiceLineGridPreview>(url, serviceLine)
          .pipe(
            catchError(this.handleError('FetchDuplicateServiceLine', {}))
          );
      }
}
